import { render, staticRenderFns } from "./ViewHistoryContents.vue?vue&type=template&id=52bc0f53&scoped=true&"
import script from "./ViewHistoryContents.vue?vue&type=script&lang=js&"
export * from "./ViewHistoryContents.vue?vue&type=script&lang=js&"
import style0 from "./ViewHistoryContents.vue?vue&type=style&index=0&id=52bc0f53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc0f53",
  null
  
)

export default component.exports